import { Injectable } from '@angular/core';
import {EndpointService} from '../endpoints.service';
import {StorageService} from '../../@core/services/storage.service';
import {_COR_COY_0, AQH_HOR_0, AQH_HOR_1, AQH_HOR_2, AQH_HOR_3, AQH_HOR_4, AQH_HOR_5, AQH_HOR_6} from '../models/input.module';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class Horses {

  constructor(private endpointService: EndpointService,
              private storageService: StorageService) {
  }

  getHorses(params: AQH_HOR_0) {
    return this.endpointService.aqh_hor_0(params).pipe(map((data => {
      return data.data;
    })))
  }

  postHorse(params: AQH_HOR_1) {
    return this.endpointService.aqh_hor_1(params).pipe(map((data => {
      return data.data;
    })))
  }

  editHorse(params: AQH_HOR_2) {
    return this.endpointService.aqh_hor_2(params).pipe(map((data => {
      return data.data;
    })))
  }

  deleteHorse(params: AQH_HOR_3) {
    return this.endpointService.aqh_hor_3(params).pipe(map((data => {
      return data;
    })))
  }

  uploadHorseImage(params: AQH_HOR_4) {
    return this.endpointService.aqh_hor_4(params).pipe(map((data => {
      return data.data;
    })))
  }

  searchHorses(query: string) {
    return this.endpointService.aqh_hor_5({ q: query }).pipe(map((data => {
      return data.data;
    })))
  }

  linkHorse(horseId: number) {
    return this.endpointService.aqh_hor_6({ horse_id: horseId }).pipe(map((data => {
      return data.data;
    })))
  }
}
